import React, { useEffect, useState } from 'react'
import tw from 'twin.macro'
import { useTranslation } from 'react-i18next'
import FileUpload from '../../_shared/FileUpload'
import OgImageCard from '../OgImageCard'
import { useFilesUploader } from '../../_shared/useFilesUploader'
import { ImageInfo } from '../../_shared/image-upload.services'
import {
  OG_IMAGE,
  OG_IMAGE_DISPLAY_WIDTH,
  OG_IMAGE_DISPLAY_HEIGHT,
} from '../../_shared/ImageConstant'
import { UploadTargetType } from '../../_shared/image-upload.services'

type SocialMediaImageSettingProps = {
  onImageUpload?: (...args: any[]) => void
  onImageDelete?: (...args: any[]) => void
  selectedOgImage?: Array<ImageInfo>
  setSelectedOgImage?: (images: Array<ImageInfo>) => void
}

export default function SocialMediaImageSettingView(props: SocialMediaImageSettingProps) {
  const { onImageUpload, onImageDelete, selectedOgImage, setSelectedOgImage } = props
  const imageType = OG_IMAGE
  const [ogImage, setOgImage] = useState(null)

  useEffect(() => {
    if (selectedOgImage[0]) {
      setOgImage(selectedOgImage[0])
    }
  }, [selectedOgImage])

  const { t } = useTranslation(['editor'])

  const useFilesHandlerInput = {
    selectedFiles: selectedOgImage,
    setSelectedFiles: setSelectedOgImage,
    imageType,
    maxImageCount: 1,
    onImageAction: onImageUpload,
    target: UploadTargetType.OG_IMAGE,
  }
  const { handleFiles } = useFilesUploader(useFilesHandlerInput)

  const renderChild = () => {
    if (ogImage) {
      return <OgImageCard data={ogImage} handleFiles={handleFiles} />
    }
  }

  return (
    <div>
      <label
        css={[tw`text-gray-800 text-h3-d leading-h1-d`, tw`mt-4 mb-2`]}
        htmlFor="social-media-image-input"
      >
        {t(['socialMediaImageInput.heading', '社群封面圖片'])}
      </label>
      <p css={[tw`text-gray-800 text-c2-d leading-c2-d`, tw`mt-2 mb-4`]}>
        {t([
          'socialMediaImageInput.description',
          '這張圖片會應用在 Facebook 等其他第三方社群平台的預覽封面。',
        ])}
      </p>
      <FileUpload
        inputId="social-media-image-input"
        onImageUpload={onImageUpload}
        maxImageCount={1}
        child={renderChild()}
        selectedFiles={selectedOgImage}
        setSelectedFiles={setSelectedOgImage}
        imageType={imageType}
        isChangeable={true}
        width={OG_IMAGE_DISPLAY_WIDTH}
        height={OG_IMAGE_DISPLAY_HEIGHT}
        target={UploadTargetType.OG_IMAGE}
      />
    </div>
  )
}
